/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod'
import { accessTokenResponseV4Schema } from './accessTokenResponseV4Schema'

export const accessTokenResponseV4ApiResponseObjectV4Schema = z
  .object({
    ok: z.boolean().default(false),
    errorMsg: z.string().nullish(),
    redirectAction: z.unknown().nullish(),
    result: accessTokenResponseV4Schema.describe(
      'A freshly issued V4 access token and when it expires. The refresh token travels in its cookie.\r\n(Named for the RESPONSE — EP.Lib.Services.Auth.TokenPairV4 is the internal pair that also\r\ncarries the refresh token, which never leaves the API in a body.)'
    ),
  })
  .describe(
    'Typed variant of EP.Models.ViewModels.ApiResponseObjectV4, used in `[ProducesResponseType]` so Swagger renders\r\nthe real `result` schema instead of the bare `object` (which the UI shows as `"string"`).\r\nWire shape is identical to the untyped envelope — this only carries the type for the schema generator.'
  )
